<template>
  <div id="orderlist" style="width: 100%;height: 850px">
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" size="small"
        style="padding-top:0;margin-top:0">
        <el-col :xl="{ span: 5 }" :lg="{ span: 7 }" :md="{ span: 10 }" :sm="{ span: 10 }" :xs="{ span: 10 }">
          <el-form-item label="项目点：">
            <el-select size="medium" filterable v-model="searchForm.PROJECT" placeholder="请选择" clearable>
              <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
                <span style="float: left">{{ item.PROJECT_NAME }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item>
            <el-button size="medium" type="primary" id="search" @click="queryNewOrderListData(searchForm.COMPANY, searchForm.PROJECT)"
              :loading="loading">筛选
            </el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="delayeData" border stripe style="width: 100%">
          <el-table-column type="index" width="50" min-width="50" label="序号"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点" min-width="80"></el-table-column>
          <el-table-column prop="TC_NAME" label="团餐公司" min-width="90"></el-table-column>
          <el-table-column prop="CONTACT_NAME" label="联系人" min-width="90"></el-table-column>
          <el-table-column prop="TELPHONE" label="联系电话" min-width="90"></el-table-column>
          <el-table-column label="状态" min-width="135">
            <template slot-scope="scope">
              {{ scope.row.STATUS === 1 ? '未处理' : '已拒绝' }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-circle-check-outline" @click="setTime(scope.row)">通过
              </el-button>&nbsp;&nbsp;
              <el-button type="text" size="small" icon="el-icon-circle-close-outline" @click="refuse(scope.row)"
                style="color: #F56C6C">拒绝</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  queryDelaye, denyDelaye, agreeDelaye, projectName,
} from 'api/delayeOrder';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      formLabelWidth: '120px',
      value3: date(Date.now() + 60 * 60 * 1000, '%R'),
      loading: false,
      companys: [
        {
          TC_ID: '',
          AB_Name: '',
        },
      ],
      points: [
        {
          PROJECT_ID: '',
          PROJECT_NAME: '',
        },
      ],
      editForm: {},
      editFormVisible: false,
      delayeData: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 20,
      searchForm: {
        COMPANY: '',
        PROJECT: '',
        STATUS: '',
      },
      state: ['', '未处理', '已拒绝'],
    };
  },
  methods: {
    // ------------------------------获取新订单列表
    queryNewOrderListData() {
      const params = {};
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      this.loading = true;
      queryDelaye(params)
        .then((result) => {
          if (result.length !== 0) {
            this.delayeData = result;
          } else {
            this.delayeData = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
          this.loading = false;
        }).catch((error) => {
          this.loading = false;
          this.$message.show({ text: error, type: 'error' });
        });
    },
    queryTitle() {
      projectName()
        .then((result) => {
          if (result.length !== 0) {
            this.points = result[0].project;
          } else {
            this.points = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // -------------------------------拒绝申请
    refuse(row) {
      this.$confirm('您确定拒绝该条申请吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          const params = {
            ID: row.ID,
          };
          denyDelaye(params)
            .then((result) => {
              this.$message.show({ text: '拒绝申请成功', type: 'success' });
              // this.queryNewOrderListData()
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
            });
        }).catch(() => {
          this.$message.show({ type: 'info', text: '取消操作' });
        });
    },
    // ---------------------------------同意申请
    setTime(row) {
      this.$confirm('您确定同意该条申请吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          const params = {
            ID: row.ID,
            ORDER_DEADLINE: this.value3,
          };
          agreeDelaye(params)
            .then((result) => {
              this.$message.show({ text: '申请成功', type: 'success' });
              this.queryNewOrderListData();
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
            });
        }).catch(() => {
          this.$message.show({ type: 'info', text: '取消操作' });
        });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryNewOrderListData();
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryNewOrderListData();
    this.queryTitle();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/audit/delayedReview.vue